import { type PropsWithChildren, useEffect, useState } from 'react'
import { LoadingPageIcon } from '@/assets/icons/loading-page-icon'
import { cn } from '@/lib/utils'

interface LoadingWrapperProps extends PropsWithChildren {
  text?: string
  isLoading?: boolean
  className?: string
  onlyFirstLoad?: boolean
}

export const LoadingWrapper = ({
  text = 'Carregando...',
  isLoading = false,
  onlyFirstLoad = true,
  children,
  className
}: LoadingWrapperProps) => {
  const [hasLoadedOnce, setHasLoadedOnce] = useState(false)
  const [isVisible, setIsVisible] = useState(isLoading)

  useEffect(() => {
    if (!onlyFirstLoad) {
      setIsVisible(isLoading)
      return
    }

    if (!isLoading && !hasLoadedOnce) {
      setIsVisible(false)

      const timer = setTimeout(() => {
        setHasLoadedOnce(true)
      }, 500)

      return () => clearTimeout(timer)
    }

    if (isLoading) {
      setIsVisible(true)
    }
  }, [isLoading, hasLoadedOnce, onlyFirstLoad])

  const shouldShowLoading = isLoading && (!onlyFirstLoad || !hasLoadedOnce)

  if (shouldShowLoading) {
    return (
      <div
        className={cn(
          `w-full h-full bg-background text-[var(--brand-blue-3)] flex flex-col gap-5 justify-center items-center transition-opacity duration-300 ${
            isVisible ? 'opacity-100' : 'opacity-0'
          }`,
          className
        )}
      >
        <LoadingPageIcon />
        <p className="text-3xl font-bold">{text}</p>
      </div>
    )
  }

  return <div className="animate-in fade-in-0 duration-500">{children}</div>
}
